import { useRef, useState } from 'react';
import { Drawer } from '@navi/web-ui/lib/primitives';
import { AddAgencyDrawerProps } from '../../interfaces/types';
import { AgencyForm } from '../forms/AgencyForm';
import { DrawerFooter } from '../DrawerFooter';

const AddAgencyDrawer = (props: AddAgencyDrawerProps) => {
  const { isDrawerOpen, onClose } = props;
  const [isOutsideClick, setIsOutsideClicked] = useState(false);
  const [isSubmitButtonDisabled, setIsSubmitButtonDisabled] = useState(false);
  const agencyFormRef = useRef<any>(null);
  const handleSubmitClick = () => {
    if (agencyFormRef?.current) {
      agencyFormRef.current?.submitForm();
    }
  };

  const handleExitYesClick = () => {
    setIsOutsideClicked(false);
    onClose();
  };

  const [isDirtyField, setIsDirtyField] = useState(false);

  const handleExitNoClick = () => {
    setIsOutsideClicked(false);
  };

  const toggleOutsideClick = () => {
    if (isDirtyField) {
      setIsOutsideClicked(true);
    } else {
      setIsOutsideClicked(false);
      onClose();
    }
  };

  return (
    <Drawer
      open={isDrawerOpen}
      headerText="Add Agency"
      showHeaderDivider={true}
      usePadding={false}
      contentClasses="overflow-auto"
      onClose={isDirtyField ? toggleOutsideClick : onClose}
      onOutSideClick={toggleOutsideClick}
      className="!w-[415px]"
      disableOutsideClick={isDirtyField ? true : false}
      footerContainerClasses={isOutsideClick ? '!bg-[var(--navi-color-red-bg)]' : ''}
      footer={
        <DrawerFooter
          handleSubmitClick={handleSubmitClick}
          isSubmitButtonDisabled={isSubmitButtonDisabled}
          handleExitYesClick={handleExitYesClick}
          handleExitNoClick={handleExitNoClick}
          onClose={onClose}
          toggleOutsideClick={toggleOutsideClick}
          isDirtyField={isDirtyField}
          isOutsideClick={isOutsideClick}
          isEditAgencyPage={false}
        />
      }
    >
      <section>
        <AgencyForm
          ref={agencyFormRef}
          onClose={onClose}
          isDrawerOpen={isDrawerOpen}
          setIsSubmitButtonDisabled={setIsSubmitButtonDisabled}
          setIsDirtyField={setIsDirtyField}
        />
      </section>
    </Drawer>
  );
};
export default AddAgencyDrawer;
